import { JobTypeId, TmJobTypeResponse } from '@business/entities/tm/TmJobTypeResponse';
import { Endpoint } from '../endpoint';

export function fetchJobTypes() {
  return Endpoint.get<TmJobTypeResponse[]>(`@gc/job-types`);
}

export function fetchJobType(id: JobTypeId) {
  return Endpoint.get<TmJobTypeResponse>(`@gc/job-types/region/${id}`);
}

export function createJobType(type: string) {
  return Endpoint.post<TmJobTypeResponse>(`@gc/job-types`, { data: { type } });
}

export function updateJobType(id: JobTypeId, type: string) {
  return Endpoint.patch<TmJobTypeResponse>(`@gc/job-types/${id}`, { data: { type } });
}

export function deleteJobType(id: JobTypeId) {
  return Endpoint.delete<void>(`@gc/job-types/${id}`);
}
